import { number, shape, string } from 'prop-types';

export default shape({
    id: number.isRequired,
    code: string,
    label: string.isRequired,
});
